/**
 * サイト設定の Composition 入口。
 * 正本は plugins/site.js（Vue.prototype.$site）。ここでは env 由来のスカラーを共有する。
 * 実行時に変わらない値なので module 級定数 + computed で公開する。
 */
import { computed, type ComputedRef } from 'vue'

const deviceMode = process.env.VUE_APP_DEVICE_MODE ?? ''
const siteFlagEnv = process.env.VUE_APP_SITE_FLAG ?? ''
const siteName = process.env.VUE_APP_SITE_NAME ?? ''
const siteId = process.env.VUE_APP_SITE_ID ?? ''

export type UseSiteReturn = {
  /** アプリ WebView 判定など。'b' がアプリ */
  appFlag: ComputedRef<string>
  siteFlag: ComputedRef<string>
  name: ComputedRef<string>
  id: ComputedRef<string>
  isAppWebView: ComputedRef<boolean>
}

/**
 * サイトフラグ・識別子。どこから呼んでも同じ module 級状態を返す。
 */
export function useSite(): UseSiteReturn {
  const appFlag = computed(() => deviceMode)
  const siteFlag = computed(() => siteFlagEnv)
  const name = computed(() => siteName)
  const id = computed(() => siteId)
  const isAppWebView = computed(() => deviceMode === 'b')

  return {
    appFlag,
    siteFlag,
    name,
    id,
    isAppWebView
  }
}
